/**
 * Farbauswahl wie im Schicht-Editor: nativer Farbwähler (freie Farbe) zuerst, dann ein Divider und feste
 * Vorschlags-Swatches. Ohne feste IDs, damit sie in mehreren Dialogen verwendbar ist.
 */

/**
 * @param {object} optionen
 * @param {string} optionen.wert aktuelle Farbe (#rrggbb)
 * @param {array<string>} optionen.vorschlaege Vorschlagsfarben
 * @param {function} optionen.onChange (farbe) => void
 * @returns {{ element: HTMLElement, setzeWert: function(string): void }} setzeWert für Änderungen von außen
 *   (z.B. eine Vorlage), ohne onChange auszulösen
 */
function baueFarbAuswahl({ wert, vorschlaege, onChange }) {
	const wrap = document.createElement('div');
	wrap.className = 'swatches';
	wrap.style.cssText = 'height:40px;align-items:center;';

	const input = document.createElement('input');
	input.type = 'color';
	input.className = 'farbwahl';
	input.title = 'Eigene Farbe';
	input.value = wert;
	wrap.appendChild(input);

	const divider = document.createElement('span');
	divider.className = 'sw-divider';
	wrap.appendChild(divider);

	const markiere = () => {
		wrap.querySelectorAll('.sw').forEach((sw) => sw.classList.toggle('on', sw.dataset.farbe.toLowerCase() === input.value.toLowerCase()));
	};
	vorschlaege.forEach((farbe) => {
		const sw = document.createElement('button');
		sw.type = 'button';
		sw.className = 'sw';
		sw.dataset.farbe = farbe;
		sw.style.background = farbe;
		sw.title = farbe;
		sw.addEventListener('click', () => {
			input.value = farbe;
			markiere();
			onChange(farbe);
		});
		wrap.appendChild(sw);
	});
	input.addEventListener('input', () => {
		markiere();
		onChange(input.value);
	});
	markiere();

	return {
		element: wrap,
		setzeWert: (farbe) => {
			input.value = farbe;
			markiere();
		},
	};
}

export { baueFarbAuswahl };
